/* ═══════════════════════════════════════════════════════════════════════
   FizzyIQ — Global header behavior
     • Promo bar carousel (auto-rotate every 6s, manual prev/next).
     • Frosted navigation over photography and dark sections, solid navy
       over light content. Menu and cart materials remain independent.

   Self-initializes on DOMContentLoaded. Safe to load on every page —
   each subsystem no-ops when its target DOM isn't present.
   ═══════════════════════════════════════════════════════════════════════ */
(function () {

  function initPromoCarousel() {
    var promoBar = document.getElementById('promoBar');
    if (!promoBar) return;
    var slides = promoBar.querySelectorAll('.promo-slide');

    if (slides.length <= 1) {
      // Single slide (or none) — hide the chevrons, no rotation needed
      var arrows = promoBar.querySelectorAll('.promo-arrow');
      arrows.forEach(function (a) { a.style.display = 'none'; });
      return;
    }

    var idx = 0;
    var timer = null;

    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        s.classList.toggle('active', n === idx);
      });
    }
    function startTimer() {
      stopTimer();
      timer = setInterval(function () { show(idx + 1); }, 6000);
    }
    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    var prevBtn = promoBar.querySelector('.promo-arrow.prev');
    var nextBtn = promoBar.querySelector('.promo-arrow.next');
    if (prevBtn) prevBtn.addEventListener('click', function () { show(idx - 1); startTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show(idx + 1); startTimer(); });
    startTimer();
  }

  function initHeaderTheme() {
    var header = document.querySelector('.gh');
    if (!header) return;
    var pdpHero = document.querySelector('.pdp-hero');
    // Phones: any page whose opening is a full-width photo gets the frosted header
    // while that photo sits under it (Sam 2026-09-21). Desktop stays solid navy
    // everywhere except the PDP (Sam 2026-09-16).
    var mobileMQ = window.matchMedia('(max-width: 820px)');
    var surfaces = [];
    var themedSurfaces = [];
    var pending = false;
    var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    var heroTypes = [
      ['.fzh', '.fzh__media', '.fzh__card'],
      ['.ffh', '.ffh__image', '.ffh__panel'],
      ['.fcta-product', '.fcta-product__media', '.fcta-product__copy'],
      ['.pdp-hero', '', ''],
      ['.sv-hero', '.sv-hero__media', '.sv-hero__copy'],
      ['.scih', '.scih-media', '.scih-copy'],
      ['.fp-faq-hero.has-img', '.fp-faq-hero-video,.fp-faq-hero-img', '.fp-faq-hero-card'],
      ['.pi-hero.has-img', '.pi-hero-video,.pi-hero-img', '.pi-hero-card'],
      ['.pr-hero.has-img', '.pr-hero-video,.pr-hero-img', '.pr-hero-card'],
      ['.fsh', '.fsh-bgs', ''],
      ['.fizzy-home-hero', '.fhh-media', ''],
      // Science and mission: the photo itself starts below the announcement bar, so the
      // test reads the hero band that contains it.
      ['.sfh', '', '.sfh__content'],
      ['.fmh', '.fmh__stage', '.fmh__copy']
    ];

    function collect() {
      surfaces = [];
      themedSurfaces = Array.from(document.querySelectorAll('[data-header-theme="dark"],[data-header-theme="light"]'));
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver.observe(header);
        if (pdpHero) resizeObserver.observe(pdpHero);
        themedSurfaces.forEach(function (surface) { resizeObserver.observe(surface); });
      }
      heroTypes.forEach(function (type) {
        document.querySelectorAll(type[0]).forEach(function (hero) {
          var media = type[1] ? hero.querySelector(type[1]) : hero;
          if (!media) return;
          var card = type[2] ? hero.querySelector(type[2]) : null;
          surfaces.push({ media: media, card: card });
          if (resizeObserver) {
            resizeObserver.observe(media);
            if (card) resizeObserver.observe(card);
          }
        });
      });
      schedule();
    }

    function update() {
      pending = false;
      var headerBounds = header.getBoundingClientRect();
      // Follow the actual photo edge. Once a white copy card reaches the
      // header, keep the solid reading surface through the rest of that hero.
      var overPhoto = surfaces.some(function (surface) {
        var bounds = surface.media.getBoundingClientRect();
        if (!bounds.width || !bounds.height || bounds.left > headerBounds.left + 1 ||
            bounds.right < headerBounds.right - 1) return false;
        var bottom = bounds.bottom;
        if (surface.card && surface.card.getClientRects().length) {
          bottom = Math.min(bottom, surface.card.getBoundingClientRect().top);
        }
        // 3px, not 1: at a browser zoom other than 100% the hero's top lands on a
        // fraction while the page is at the very top, and 1px read that as "not
        // over the hero", so the header went solid only at the top (Sam 2026-09-16).
        // iOS rubber-band at the top pulls the hero down while the fixed bar stays put;
        // read the hero where it will settle so the bar does not flip solid and back.
        var overscroll = Math.min(0, window.scrollY || 0);
        return bounds.top + overscroll <= headerBounds.top + 3 && bottom > headerBounds.bottom;
      });
      var overDark = false;
      themedSurfaces.forEach(function (surface) {
        var bounds = surface.getBoundingClientRect();
        // Inset dark cards do not change the page's header material. Require
        // a full-width dark surface behind the whole header; mixed edges stay
        // solid. Later nested light regions take precedence over their parent.
        if (bounds.left > headerBounds.left + 1 || bounds.right < headerBounds.right - 1 ||
            bounds.bottom <= headerBounds.top || bounds.top >= headerBounds.bottom) return;
        if (surface.getAttribute('data-header-theme') === 'light') overDark = false;
        else if (bounds.top <= headerBounds.top + 3 && bounds.bottom > headerBounds.bottom) overDark = true;
      });
      // Frosted glass: always on the PDP; on phones also over full-width photo
      // openings. Everywhere else the solid navy bar stays (Sam 2026-09-16, 2026-09-21).
      var mobileGlass = !pdpHero && mobileMQ.matches && surfaces.length > 0;
      var glass = !!pdpHero || mobileGlass;
      // Full-width dark surfaces lift the glass only on the PDP (Sam 2026-09-16). A phone
      // photo page goes solid once its opening has scrolled past, footer included.
      var overDarkGlass = !!pdpHero && overDark && !overPhoto;
      document.body.classList.toggle('header-photo-mobile', mobileGlass);
      document.body.classList.toggle('header-over-hero', glass && overPhoto);
      document.body.classList.toggle('header-over-dark', overDarkGlass);
      document.body.classList.toggle('header-on-light', !glass || (!overPhoto && !overDarkGlass));
      if (pdpHero) {
        document.body.classList.toggle('pdp-hero-active', pdpHero.getBoundingClientRect().bottom > headerBounds.bottom);
      }
    }
    function schedule() {
      if (!pending) { pending = true; requestAnimationFrame(update); }
    }
    document.body.classList.remove('header-over-sample-photo', 'header-floating');
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('scrollend', schedule, { passive: true });
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', schedule); else if (mobileMQ.addListener) mobileMQ.addListener(schedule);
    // Re-measure once the scroll has settled, for browsers that end a momentum
    // scroll without a final scroll or scrollend event.
    var settle = null;
    window.addEventListener('scroll', function () {
      if (settle) clearTimeout(settle);
      settle = setTimeout(schedule, 160);
    }, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', collect);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    collect();
    update();
  }

  /* Floating-header pattern removed 2026-06-07 (Sam) — the header is now
     full-width on every page with no floating/inset state. */

  /* Mobile menu — hamburger (.menu-btn) toggles a drop-down panel
     (#mobileMenu) anchored beneath the header, with a separate scrim
     (#mobileMenuScrim) dimming everything below the header. Both
     elements share an .open class. Close on: (1) ESC key, (2) tap on
     the scrim, (3) any nav link click (auto-close on navigation),
     (4) tapping the hamburger again. Added 2026-05-26 after Sam
     flagged the missing handler; restructured to drop-down-beneath-
     header per follow-up. */
  /* Sample-kit triggers, site-wide (Sam 2026-09-04). The splash page is not
     ready, so every "try all flavors" entry point opens the Klaviyo form
     instead of navigating. Delegated and guarded so it covers markup added
     later and binds exactly once; it lived in fizzy-pdp-hero.js before, which
     only loads on the PDP and never cancelled the anchor's navigation. */
  function initSampleKitTriggers() {
    if (window.__fizzySampleKit) return;
    window.__fizzySampleKit = true;
    document.addEventListener('click', function (e) {
      var t = e.target.closest && e.target.closest('[data-bb-sample]');
      if (!t) return;
      e.preventDefault();
      e.stopPropagation();
      /* These triggers used to be links, so navigating away is what dismissed
         the mobile tray. Now that navigation is cancelled, the tray would stay
         open over the Klaviyo form with the body still scroll-locked, which
         reads as "the form didn't open". Close it first. Sam 2026-09-04. */
      var tray = document.getElementById('mobileMenu');
      if (tray && tray.classList.contains('open') && typeof window.__fizzyCloseMobileMenu === 'function') {
        window.__fizzyCloseMobileMenu();
      }
      var formId = t.getAttribute('data-klaviyo-form');
      if (formId && formId !== 'REPLACE_WITH_KLAVIYO_FORM_ID') {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', formId]);
      } else {
        console.warn('[FizzyIQ] Sample-kit trigger has no data-klaviyo-form.');
      }
    });
  }

  function initMobileMenu() {
    var menuBtn = document.querySelector('.gh .menu-btn');
    var menu = document.getElementById('mobileMenu');
    var header = document.querySelector('.gh');
    if (!menuBtn || !menu || menu.dataset.initialized) return;
    var accountBtn = header.querySelector('.account-btn');
    var returnFocus = menuBtn;
    menu.dataset.initialized = 'true';
    var inerted = [];
    var previousOverflow = '';
    var tabs = Array.prototype.slice.call(menu.querySelectorAll('[data-mm-tab]'));
    var panels = Array.prototype.slice.call(menu.querySelectorAll('[data-mm-panel]'));
    var menuContent = menu.querySelector('.mm-content');
    var tabList = menu.querySelector('.mm-tabs');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var panelMotion = null;
    tabList.style.setProperty('--mm-tab-count', tabs.length);

    function stopPanelMotion() {
      if (panelMotion) panelMotion.cancel();
      panelMotion = null;
    }
    function revealPanel(panel, direction) {
      stopPanelMotion();
      if (reducedMotion.matches || !panel.animate || !menu.classList.contains('open')) return;
      // Follow the tab's position; keep the destination usable immediately.
      panelMotion = panel.animate([
        { opacity: .45, transform: 'translateX(' + (direction * 12) + 'px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 180, easing: 'cubic-bezier(.16,1,.3,1)' });
      panelMotion.onfinish = function () { panelMotion = null; };
    }
    reducedMotion.addEventListener('change', function () {
      if (reducedMotion.matches) stopPanelMotion();
    });

    function selectTab(tab, focus) {
      var key = tab.getAttribute('data-mm-tab');
      var previous = tabs.findIndex(function (item) { return item.getAttribute('aria-selected') === 'true'; });
      var next = tabs.indexOf(tab);
      if (previous === next) {
        if (focus) tab.focus({ preventScroll: true });
        return;
      }
      stopPanelMotion();
      tabs.forEach(function (item) {
        var selected = item === tab;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-selected', String(selected));
        item.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var selected = panel.getAttribute('data-mm-panel') === key;
        panel.hidden = !selected;
        panel.classList.toggle('is-active', selected);
        if (selected) revealPanel(panel, next > previous ? 1 : -1);
      });
      if (menuContent) menuContent.scrollTop = 0;
      if (focus) tab.focus({ preventScroll: true });
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { selectTab(tab, false); });
      tab.addEventListener('keydown', function (event) {
        var next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault();
        selectTab(tabs[next], true);
      });
    });

    function positionToHeader() {
      menu.style.top = Math.round(header.getBoundingClientRect().bottom) + 'px';
    }
    function isolate() {
      // Keep the header and tray available while excluding the page beneath.
      // They share the same Shopify section; climb outward and remember only
      // attributes this controller adds so another overlay's state survives.
      var branch = header.closest('.shopify-section') || header.parentElement;
      while (branch && branch.parentElement) {
        Array.prototype.forEach.call(branch.parentElement.children, function (sibling) {
          if (sibling !== branch && !sibling.hasAttribute('inert') &&
              !/^(SCRIPT|STYLE|LINK|TEMPLATE)$/.test(sibling.tagName)) {
            sibling.setAttribute('inert', '');
            inerted.push(sibling);
          }
        });
        branch = branch.parentElement;
        if (branch === document.body) break;
      }
    }
    function visibleControls() {
      return Array.prototype.slice.call(header.querySelectorAll('a[href],button,summary'))
        .concat(Array.prototype.slice.call(menu.querySelectorAll('a[href],button,summary')))
        .filter(function (el) {
          return !el.disabled && el.tabIndex >= 0 && !el.closest('[inert]') && el.getClientRects().length &&
            getComputedStyle(el).visibility !== 'hidden';
        });
    }
    function open(trigger) {
      if (menu.classList.contains('open') || window.innerWidth > 820) return;
      returnFocus = trigger || menuBtn;
      document.dispatchEvent(new CustomEvent('fizzy:overlay-open', { detail: 'menu' }));
      positionToHeader();
      previousOverflow = document.body.style.overflow;
      menu.removeAttribute('inert');
      menu.setAttribute('aria-hidden', 'false');
      menu.classList.add('open');
      menuBtn.setAttribute('aria-expanded', 'true');
      if (accountBtn) accountBtn.setAttribute('aria-expanded', 'true');
      menuBtn.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('mobile-menu-open');
      document.body.style.overflow = 'hidden';
      isolate();
      // Focus starts on the close toggle, then naturally advances through the
      // header and the menu. Nothing beneath the drawer can receive focus.
      menuBtn.focus({ preventScroll: true });
    }
    function close(restoreFocus) {
      if (!menu.classList.contains('open')) return;
      stopPanelMotion();
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      menu.setAttribute('inert', '');
      menuBtn.setAttribute('aria-expanded', 'false');
      if (accountBtn && window.innerWidth <= 820) accountBtn.setAttribute('aria-expanded', 'false');
      menuBtn.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('mobile-menu-open');
      inerted.forEach(function (el) { el.removeAttribute('inert'); });
      inerted = [];
      document.body.style.overflow = previousOverflow;
      if (restoreFocus !== false) returnFocus.focus({ preventScroll: true });
    }
    window.__fizzyCloseMobileMenu = close;
    menuBtn.addEventListener('click', function () {
      if (menu.classList.contains('open')) close(); else open();
    });
    function syncAccountTrigger() {
      if (!accountBtn) return;
      var mobile = window.innerWidth <= 820;
      accountBtn.setAttribute('aria-label', mobile ? 'Open account menu' : 'Account');
      if (mobile) {
        accountBtn.setAttribute('role', 'button');
        accountBtn.setAttribute('aria-controls', menu.id);
        accountBtn.setAttribute('aria-expanded', String(menu.classList.contains('open')));
      } else {
        accountBtn.removeAttribute('role');
        accountBtn.removeAttribute('aria-controls');
        accountBtn.removeAttribute('aria-expanded');
      }
    }
    if (accountBtn) {
      accountBtn.addEventListener('click', function (e) {
        if (window.innerWidth > 820) return;
        var accountTab = tabs.find(function (tab) { return tab.getAttribute('data-mm-tab') === 'account'; });
        if (!accountTab) return;
        e.preventDefault();
        selectTab(accountTab, false);
        open(accountBtn);
        returnFocus = accountBtn;
        accountTab.focus({ preventScroll: true });
      });
      accountBtn.addEventListener('keydown', function (e) {
        if (window.innerWidth <= 820 && e.key === ' ') {
          e.preventDefault();
          accountBtn.click();
        }
      });
      syncAccountTrigger();
    }
    menu.addEventListener('click', function (e) {
      if (e.target.closest('a[href]')) close(false);
    });
    document.addEventListener('keydown', function (e) {
      if (!menu.classList.contains('open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var controls = visibleControls();
      var first = controls[0], last = controls[controls.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    });
    document.addEventListener('fizzy:overlay-open', function (e) {
      if (e.detail !== 'menu') close(false);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 820) close(false);
      else if (menu.classList.contains('open')) positionToHeader();
      syncAccountTrigger();
    }, { passive: true });
  }

  function initDesktopMenus() {
    var header = document.querySelector('.gh');
    if (!header) return;
    var menus = Array.prototype.slice.call(header.querySelectorAll('.gh-menu'));
    var desktopHover = window.matchMedia('(min-width: 821px) and (any-hover: hover) and (any-pointer: fine)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var panelMotion = null;
    function stopPanelMotion() {
      if (panelMotion) panelMotion.cancel();
      panelMotion = null;
    }
    reducedMotion.addEventListener('change', function () {
      if (reducedMotion.matches) stopPanelMotion();
    });
    var hoverCloseTimer = null;
    var hoverOpenTimer = null;
    function cancelHoverOpen() {
      clearTimeout(hoverOpenTimer);
      hoverOpenTimer = null;
    }
    function cancelHoverClose() {
      clearTimeout(hoverCloseTimer);
      hoverCloseTimer = null;
    }
    function closeMenus(except) {
      cancelHoverOpen();
      cancelHoverClose();
      stopPanelMotion();
      menus.forEach(function (menu) {
        if (menu !== except) {
          menu.open = false;
          menu.classList.remove('is-switching');
        }
      });
    }
    function openMenu(menu) {
      cancelHoverOpen();
      cancelHoverClose();
      if (menu.open) return;
      var previous = menus.find(function (item) { return item.open; });
      closeMenus(menu);
      // Keep the white surface fully visible during sibling navigation.
      // Only a first opening uses the header-attached reveal.
      menu.classList.toggle('is-switching', !!previous);
      menu.open = true;
      var content = menu.querySelector('.gh-menu-inner');
      if (!previous || reducedMotion.matches || !content || !content.animate) return;
      var direction = menus.indexOf(menu) > menus.indexOf(previous) ? 1 : -1;
      panelMotion = content.animate([
        { opacity: .25, transform: 'translateX(' + (direction * 16) + 'px)' },
        { opacity: 1, transform: 'translateX(0)' }
      ], { duration: 200, easing: 'cubic-bezier(.16,1,.3,1)' });
      panelMotion.onfinish = function () { panelMotion = null; };
    }
    function isHovered(menu) {
      return desktopHover.matches && menu.matches(':hover');
    }
    menus.forEach(function (menu) {
      menu.addEventListener('pointerenter', function (e) {
        if (!desktopHover.matches || e.pointerType !== 'mouse') return;
        cancelHoverOpen();
        cancelHoverClose();
        if (menu.open) return;
        // Crossing a trigger on the way to a destination should not switch panels.
        hoverOpenTimer = setTimeout(function () {
          hoverOpenTimer = null;
          if (!isHovered(menu)) return;
          openMenu(menu);
        }, 100);
      });
      menu.addEventListener('pointerleave', function (e) {
        if (!desktopHover.matches || e.pointerType !== 'mouse') return;
        cancelHoverOpen();
        if (!menu.open) return;
        cancelHoverClose();
        // Keep the panel reachable across the header edge, and retain it
        // while someone is using its links with the keyboard.
        hoverCloseTimer = setTimeout(function () {
          if (!menu.contains(document.activeElement) && !isHovered(menu)) {
            menu.open = false;
          }
          hoverCloseTimer = null;
        }, 200);
      });
      menu.querySelector('summary').addEventListener('click', function (e) {
        e.preventDefault();
        // Retain mouse-hover ownership; keyboard/touch can toggle closed.
        var mouseHover = e.detail > 0 && e.pointerType !== 'touch' &&
          e.pointerType !== 'pen' && isHovered(menu);
        if (menu.open && !mouseHover) closeMenus();
        else openMenu(menu);
      });
      menu.addEventListener('click', function (e) { if (e.target.closest('a[href]')) menu.open = false; });
      menu.addEventListener('focusout', function () {
        setTimeout(function () {
          if (!menu.contains(document.activeElement) && !isHovered(menu)) menu.open = false;
        }, 0);
      });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var active = menus.find(function (menu) { return menu.open; });
      if (active) {
        var restoreFocus = active.contains(document.activeElement);
        e.preventDefault(); closeMenus();
        if (restoreFocus) active.querySelector('summary').focus({ preventScroll: true });
      }
      var account = header.querySelector('.account-item');
      if (account && account.contains(document.activeElement)) {
        account.classList.add('is-dismissed');
        account.querySelector('.account-btn').focus({ preventScroll: true });
      }
    });
    var account = header.querySelector('.account-item');
    if (account) {
      account.addEventListener('mouseenter', function () { account.classList.remove('is-dismissed'); closeMenus(); });
      account.addEventListener('focusout', function () {
        setTimeout(function () { if (!account.contains(document.activeElement)) account.classList.remove('is-dismissed'); }, 0);
      });
    }
    document.addEventListener('click', function (e) { if (!header.contains(e.target)) closeMenus(); });
    document.addEventListener('fizzy:overlay-open', function () { closeMenus(); });
    window.addEventListener('resize', function () { if (window.innerWidth <= 820) closeMenus(); }, { passive: true });
  }

  /* Publish the actual header height for reading offsets, hero copy
     clearance, menu positioning and sticky controls. */
  function publishHeight() {
    var gh = document.querySelector('.gh');
    if (!gh) return;
    document.documentElement.style.setProperty('--gh-h', gh.offsetHeight + 'px');
    /* Photo heroes start their picture below the announcement bar (fizzy-header.css). */
    var announcement = gh.querySelector('.gh-announcement');
    document.body.style.setProperty('--gh-ann-h', (announcement ? announcement.offsetHeight : 0) + 'px');
  }

  function init() {
    initPromoCarousel();
    initHeaderTheme();
    initSampleKitTriggers();
    initMobileMenu();
    initDesktopMenus();
    publishHeight();
    var measuredHeader = document.querySelector('.gh');
    if (measuredHeader && window.ResizeObserver) {
      var headerSizeObserver = new ResizeObserver(publishHeight);
      headerSizeObserver.observe(measuredHeader);
    }
    window.addEventListener('resize', publishHeight, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
